export default __webpack_public_path__ + "static/media/chair.8ec11ed9.png";